import { defineStore } from "pinia"
import { createDiscreteApi } from "naive-ui"

const { notification, dialog } = createDiscreteApi(['notification', 'dialog'])

export const useDefaultStore = defineStore('default', {
  state: () => ({
    loading: false,
    pageTitle: '',
  })
})